import React from 'react'

const MobileFilterCategories = () => {
	return (
		<div>
			<div className='mb-3'>
				<h5 className='text-normal text-black'>Categories</h5>
			</div>
			<div class='accordion-1 mb-2 p-0'>
				<div class='accordion active' id='accordionWomen'>
					<div class='accordion-item mb-0'>
						<h6 class='accordion-header' id='headingWomen'>
							<button
								class='accordion-button p-0 align-items-baseline font-weight-bold text-xl'
								type='button'
								data-bs-toggle='collapse'
								data-bs-target='#collapseWomen'
								aria-expanded='false'
								aria-controls='collapseWomen'
							>
								<h6 className='text-dark text-normal'>Women</h6>
								<small class='collapse-close  text-sm pt-1 position-absolute end-0 me-3'>
									<img src='../../assets/img/svg/down.svg' alt='' />
								</small>
								<small class='collapse-open text-sm pt-1 position-absolute end-0 me-3'>
									<img src='../../assets/img/svg/up.svg' alt='' />
								</small>
							</button>
						</h6>
						<div id='collapseWomen' class='accordion-collapse collapse' aria-labelledby='headingWomen' data-bs-parent='#accordionWomen'>
							<div class='accordion-body text-start text-sm'>
								<div className='input-group input-group-outline mb-3'>
									<input type='text' className='form-control w-100' placeholder='Search for categories' />
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Blazzers & Waistcoats <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Blouses <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Chudidhar & Leggings <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Dress Materials <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Dresses & Gowns <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Dresses <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Dupatas <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Jeans & Jeggings <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Kurtas <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Night & Lounge sets <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Pants <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Sarees <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Suit Sets <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Track Pants <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class='accordion-2 mb-2 p-0'>
				<div class='accordion ' id='accordionGirls'>
					<div class='accordion-item mb-0'>
						<h6 class='accordion-header' id='headingGirls'>
							<button
								class='accordion-button p-0 align-items-baseline font-weight-bold text-xl'
								type='button'
								data-bs-toggle='collapse'
								data-bs-target='#collapseGirls'
								aria-expanded='false'
								aria-controls='collapseGirls'
							>
								<h6 className='text-dark text-normal'>Girls</h6>
								<small class='collapse-close  text-sm pt-1 position-absolute end-0 me-3'>
									<img src='../../assets/img/svg/down.svg' alt='' />
								</small>
								<small class='collapse-open text-sm pt-1 position-absolute end-0 me-3'>
									<img src='../../assets/img/svg/up.svg' alt='' />
								</small>
							</button>
						</h6>
						<div id='collapseGirls' class='accordion-collapse collapse' aria-labelledby='headingGirls' data-bs-parent='#accordionGirls'>
							<div class='accordion-body text-start text-sm'>
								<div className='input-group input-group-outline mb-3'>
									<input type='text' className='form-control w-100' placeholder='Search for categories' />
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Casual Shoes <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Chudidhar & Leggings <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Dresses & Frocks <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>

								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Dress Materials <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Ethinic Wear Sets <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Jackets & Shrugs <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Jumpsuits & Playsuits <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Jeans & Jeggings <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Kurtas & Kurtis <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Night & Lounge sets <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Pants <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Sarees <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Skirts <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Western Wear Sets <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class='accordion-3 mb-2 p-0'>
				<div class='accordion ' id='accordionMen'>
					<div class='accordion-item mb-0'>
						<h6 class='accordion-header' id='headingMen'>
							<button
								class='accordion-button p-0 align-items-baseline font-weight-bold text-xl'
								type='button'
								data-bs-toggle='collapse'
								data-bs-target='#collapseMen'
								aria-expanded='false'
								aria-controls='collapseMen'
							>
								<h6 className='text-dark text-normal'>Men</h6>
								<small class='collapse-close  text-sm pt-1 position-absolute end-0 me-3'>
									<img src='../../assets/img/svg/down.svg' alt='' />
								</small>
								<small class='collapse-open text-sm pt-1 position-absolute end-0 me-3'>
									<img src='../../assets/img/svg/up.svg' alt='' />
								</small>
							</button>
						</h6>
						<div id='collapseMen' class='accordion-collapse collapse' aria-labelledby='headingMen' data-bs-parent='#accordionMen'>
							<div class='accordion-body text-start text-sm'>
								<div className='input-group input-group-outline mb-3'>
									<input type='text' className='form-control w-100' placeholder='Search for categories' />
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Casual Shirts <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Jackets & Coats <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Jeans <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Kurtas & Shirts <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Suit Sets <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Suitings & Shirtings <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Track Pants <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Tracksuits <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Travel Bags <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Trouser & Pants <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Tshirts <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Wallets <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Watches <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Accessories <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class='accordion-4 mb-2 p-0'>
				<div class='accordion ' id='accordionBoys'>
					<div class='accordion-item mb-0'>
						<h6 class='accordion-header' id='headingBoys'>
							<button
								class='accordion-button p-0 align-items-baseline font-weight-bold text-xl'
								type='button'
								data-bs-toggle='collapse'
								data-bs-target='#collapseBoys'
								aria-expanded='false'
								aria-controls='collapseBoys'
							>
								<h6 className='text-dark text-normal'>Boys</h6>
								<small class='collapse-close  text-sm pt-1 position-absolute end-0 me-3'>
									<img src='../../assets/img/svg/down.svg' alt='' />
								</small>
								<small class='collapse-open text-sm pt-1 position-absolute end-0 me-3'>
									<img src='../../assets/img/svg/up.svg' alt='' />
								</small>
							</button>
						</h6>
						<div id='collapseBoys' class='accordion-collapse collapse' aria-labelledby='headingBoys' data-bs-parent='#accordionBoys'>
							<div class='accordion-body text-start text-sm'>
								<div className='input-group input-group-outline mb-3'>
									<input type='text' className='form-control w-100' placeholder='Search for categories' />
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											2 Piece Kurta sets <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Backpacks <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Bag Accessories <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Bags & Wallets <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Clothing Accessories <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Ethinic Sets <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Fashion Accessories <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Innerwear Sets <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Kurtas <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Nightsuit sets <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Pyjamas <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Sandals <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Shorts <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
								<div>
									<div class='form-check p-0 mb-2'>
										<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
										<label class='custom-control-label ms-3' for='customCheck1'>
											Sneakers <small className='text-dark ms-1'>(10,000)</small>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default MobileFilterCategories
